import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, from, Observable, throwError } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthentificationService } from '../../services/auth/authentification.service';
import { Router } from '@angular/router';
import { AuthConstants } from 'src/app/constants/auth/auth-constants';

@Injectable()
export class RefreshInterceptor implements HttpInterceptor {

    constructor(private authentificationService: AuthentificationService, private router: Router) { }

    isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError((error:any) => {
            if (error instanceof HttpErrorResponse && error.status === 401 && !request.url.includes(AuthConstants.AUTH_ENDPOINT + AuthConstants.LOGIN_URL)) {
                return this.handle401Error(request, next);
            } else {
                return throwError(() => error);
            }
        }));
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return from(this.authentificationService.refreshAuthentification()).pipe(
                switchMap((bearer: any) => {
                    this.isRefreshing = false;
                    this.refreshTokenSubject.next(bearer);
                    return next.handle(this.updateAuthorizationRequest(request, bearer));
                }),
                catchError(() => {
                    this.isRefreshing = false;
                    this.refreshAuthentificationFailHandler();
                    return null;
                })
            );
        } else {
            return this.refreshTokenSubject.pipe(
                filter((bearer) => bearer != null),
                take(1),
                switchMap((jwt) => {
                    return next.handle(this.updateAuthorizationRequest(request, jwt));
                })
            );
        }
    }

    private updateAuthorizationRequest(request: HttpRequest<any>, storedAccess) {
        return request.clone({ 
            headers: request.headers.set('Authorization', 'Bearer ' + storedAccess.access_token)
        });
    }

    refreshAuthentificationFailHandler() {
        this.authentificationService.clearAccessStorage();
        this.router.navigate(['/auth/login']);
    }

}